import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import EvaluatorPaymentActionParamsItem from './EvaluatorPaymentActionParamsItem';

export default class VoidAndSupressWindowDescription {
  static titleForCreate = 'Void and Supress';
  static titleForEdit = 'Void and Supress';
  static finishButtonLabel = 'Void and Supress';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.VoidAndSupress(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void and Supress process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
